module.exports = __webpack_public_path__ + "img/spot_red_log.75c7e778.svg";